module.exports = __webpack_public_path__ + "media/images/home/ssl-badge-d5e3e36ed2612e0c8b3d4f2f787d6d4c.svg";